

































import { Component, Vue } from 'vue-property-decorator';
import { Address, ConfirmedTransactionListener } from 'nem-library';

@Component({
  components: {

  },
})
export default class Home extends Vue {
  private address: string = '';
  private startedListner: boolean = false;
  private message: any = '';
 
  private async startListner() {
    const confirmedTransactionListener = new ConfirmedTransactionListener([
      {
        domain: '23.228.67.85'
      },
    ]).given(new Address(this.address));
    confirmedTransactionListener.subscribe((result) => {
      console.log(result);
      this.message = result;
    }, (err) => {
      console.log(err);
    });
    this.startedListner = true;
 }
}
